"use client";

import React, { lazy, Suspense } from "react";
import { Card, Box, Typography } from "@mui/material";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";

const Chart = lazy(() => import("react-apexcharts"));

const LossesCard = ({ data = {} }) => {
    // Mini sparkline for history
    const sparklineData = data.history?.map((d) => d.abandons) || [];

    const options = {
        chart: { sparkline: { enabled: true } },
        stroke: { curve: "smooth", width: 2, colors: ["#EF4444"] },
        fill: { opacity: 0.1, colors: ["#EF4444"] }, // Red fill for "Losses"
        tooltip: {
            fixed: { enabled: false },
            x: { show: false },
            y: { title: { formatter: () => "Abandons" } },
            marker: { show: false },
        },
    };

    const series = [{ name: "Abandons", data: sparklineData }];

    return (
        <Card
            sx={{
                boxShadow: "none",
                borderRadius: "7px",
                p: { xs: 2, sm: 3 },
                height: "100%",
                display: "flex",
                flexDirection: "column",
                position: "relative",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    bgcolor: "rgba(255, 255, 255, 0.6)",
                    zIndex: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backdropFilter: "blur(1px)",
                }}
            >
                <Typography variant="h5" fontWeight="bold" color="text.secondary">
                    Coming Soon...
                </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={2} mb={3}>
                <Box
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "50%",
                        bgcolor: "#FEF2F2",
                        color: "#EF4444",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <TrendingDownIcon fontSize="large" />
                </Box>
                <Box>
                    <Typography variant="h6" fontWeight={700}>
                        Losses
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Chat Abandons
                    </Typography>
                </Box>
            </Box>

            <Box>
                <Typography variant="h3" fontWeight={700} color="error.main">
                    {data.chat_abandons || 0}
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                    Conversations abandoned this week
                </Typography>

                <Box height={80}>
                    <Suspense fallback={<div />}>
                        <Chart options={options} series={series} type="area" height={80} width="100%" />
                    </Suspense>
                </Box>
            </Box>
        </Card>
    );
};

export default LossesCard;
